import { api } from '../lib/api';
import type { CustomerCategory, CustomerSite } from '../types/api';

export async function listSites(orgId: string): Promise<CustomerSite[]> {
  const { data } = await api.get<CustomerSite[]>(`/customer-organisations/${orgId}/sites`);
  return data;
}

export interface CreateSiteInput {
  name: string;
  address?: string;
  selfRegistrationEnabled?: boolean;
}

export async function createSite(orgId: string, input: CreateSiteInput): Promise<CustomerSite> {
  const { data } = await api.post<CustomerSite>(`/customer-organisations/${orgId}/sites`, input);
  return data;
}

export interface UpdateSiteInput {
  name?: string;
  address?: string;
  selfRegistrationEnabled?: boolean;
  // undefined = leave unchanged, null = clear back to "no threshold",
  // number = set/replace it (see UpdateSiteDto on the backend).
  approvalThreshold?: number | null;
}

export async function updateSite(orgId: string, siteId: string, input: UpdateSiteInput): Promise<CustomerSite> {
  const { data } = await api.patch<CustomerSite>(`/customer-organisations/${orgId}/sites/${siteId}`, input);
  return data;
}

export async function updateSiteStatus(
  orgId: string,
  siteId: string,
  status: 'ACTIVE' | 'INACTIVE',
): Promise<CustomerSite> {
  const { data } = await api.patch<CustomerSite>(`/customer-organisations/${orgId}/sites/${siteId}`, { status });
  return data;
}

// Each site keeps its own independent category list (seeded from the same
// defaults every site gets at creation) - editable from that site's own
// settings.
export async function listSiteCategories(orgId: string, siteId: string): Promise<CustomerCategory[]> {
  const { data } = await api.get<CustomerCategory[]>(`/customer-organisations/${orgId}/sites/${siteId}/categories`);
  return data;
}

export async function createSiteCategory(orgId: string, siteId: string, name: string): Promise<CustomerCategory> {
  const { data } = await api.post<CustomerCategory>(
    `/customer-organisations/${orgId}/sites/${siteId}/categories`,
    { name },
  );
  return data;
}

export async function deleteSiteCategory(orgId: string, siteId: string, categoryId: string): Promise<void> {
  await api.delete(`/customer-organisations/${orgId}/sites/${siteId}/categories/${categoryId}`);
}
